import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/book/$bookId/setup")({
  component: lazyRouteComponent(
    () => import("../pages/Book/components/BookSetupForm"),
    "BookSetupForm",
  ),
});
